module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img.ab290cc5247434f1b5b208088c0af1b9.jpg";